import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/teachers_/new-anonymous")({
  loader: ({ params }) => {
    throw redirect({
      to: "/organizations/$organizationId/admin/teachers",
      params: { organizationId: params.organizationId },
    });
  },
});
